import script from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&setup=true&lang=js"

import "./BarcodeScanner.vue?vue&type=style&index=0&id=6f1364ec&lang=css"

const __exports__ = script;

export default __exports__